// extracted by mini-css-extract-plugin
export default {"downloadButton":"reportLink_downloadButton__ueVak"};